import { PureComponent } from 'react'
import moment from 'moment'
import { DATE_FORMAT } from '../../../../../../lib/MomentHelper'
import XAxisTick from '../../../../../Common/NewDashboard/Chart/XAxisTick/XAxisTick'

class CustomizeXAxisTick extends PureComponent {
  render () {
    const { payload, x, y } = this.props
    const date = moment(payload.value, DATE_FORMAT.API_DATETIME).format(
      DATE_FORMAT.LINE_CHART_X_AXIS_DATE
    )

    return (
      <XAxisTick svgProps={{ x, y }}>
        <tspan
          x={0}
          dy={12}
        >
          {date}
        </tspan>
      </XAxisTick>
    )
  }
}

export default CustomizeXAxisTick
